import { Model } from '@vuex-orm/core'

import Workspace from './Workspace'

export class Channel extends Model {
  static entity = 'channels'
  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(null),
      config: this.attr(null),
      workspaces: this.hasMany(Workspace, 'channel_id'),
      messages: this.hasMany(ChannelMessage, 'channel_id'),
    }
  }
}


export class ChannelMessage extends Model {
  static entity = 'channelMessages'
  static fields () {
    return {
      id: this.attr(null),
      channel_id: this.attr(null),
      text: this.attr(null),
      meta: this.attr(null),
      created_at: this.attr(null),
    }
  }
}
